import { BackHeaderIOsOutlined } from '@icon';
import React from 'react';
import { useIntl } from 'react-intl';
import withBreadcrumbs from 'react-router-breadcrumbs-hoc';
import { useRouteMatch } from 'react-router-dom';
import { useTheme } from 'styled-components';
import HeaderBreadcrumbs from './components/header-breadcrumbs';
import { getFormattedPathName } from './components/header-breadcrumbs/header-breadcrumbs.utils';
import { PageHeaderSC } from './page-header.styled';
import { ICustomBreadcrumb } from './page-header.types';

export interface AbstractPageHeaderProps {
  showBreadcrumbs?: boolean;
  showDivider?: boolean;
  className?: string;

  breadcrumbs: { match: any; location: any; key: any; breadcrumb: any }[];
  customCrumbs?: ICustomBreadcrumb[];

  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  extra?: React.ReactNode;
  footer?: React.ReactNode;
  onBack?: () => void;
  children?: React.ReactNode;
}

export type PageHeaderProps = Omit<AbstractPageHeaderProps, 'breadcrumbs'>;

const PageHeader: React.FunctionComponent<AbstractPageHeaderProps> = ({
  showBreadcrumbs = true,
  showDivider,
  className,
  extra,
  footer,
  onBack,
  subTitle,
  title,
  children,
  breadcrumbs,
  customCrumbs,
}) => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const extraTitleStyle = { paddingLeft: onBack ? 0 : 12 };
  const extraStyle = { paddingLeft: onBack ? 12 : 0 };
  const { path } = useRouteMatch();

  return (
    <PageHeaderSC className={className} showDivider={showDivider} hasFooter={Boolean(footer)}>
      {showBreadcrumbs ? (
        <HeaderBreadcrumbs
          className="header-breadcrumbs"
          breadcrumbs={breadcrumbs}
          customCrumbs={customCrumbs}
        />
      ) : (
        <div className="header-breadcrumbs" />
      )}
      <div className="header-heading">
        <div className="header-title-wrapper">
          {onBack ? (
            <button className="header-title-back" onClick={onBack}>
              <BackHeaderIOsOutlined
                width={32}
                height={32}
                color={theme.color.tint.action}
                className="header-title-back-icon"
              />
            </button>
          ) : null}
          <div style={extraTitleStyle} className="header-title-container">
            <div className="header-title-title">
              {title ??
                formatMessage({
                  id: `routes.${getFormattedPathName(path)}`,
                })}
            </div>
            {subTitle ? <div className="header-title-subtitle">{subTitle}</div> : null}
          </div>
        </div>
        {extra ? <div className="header-title-extra">{extra}</div> : null}
      </div>
      {children ? (
        <div className="header-content" style={extraStyle}>
          {children}
        </div>
      ) : null}
      {footer ? (
        <div className="header-footer" style={extraStyle}>
          {footer}
        </div>
      ) : null}
    </PageHeaderSC>
  );
};

export default withBreadcrumbs()(PageHeader as any) as React.FunctionComponent<PageHeaderProps>;
